import { escListener, scrollLock } from './utils'

const miniCart = document.getElementById('mini-cart')
const miniCartOverlay = document.getElementById('mini-cart-overlay')
const body = document.querySelector('body')
const upsellItems = miniCart.querySelectorAll('.upsell-item-wrapper')

const escCallBack = () => {
  miniCart.classList.remove('open')
  miniCartOverlay.classList.remove('open')
  body.style.removeProperty('overflow')
}

document.getElementById('cart-open').addEventListener('click', function () {
  miniCart.classList.add('open')
  miniCartOverlay.classList.add('open')
  document.body.classList.add('active', 'minicart')
  escListener(true, escCallBack)
  scrollLock(true)
})

document.getElementById('cart-close').addEventListener('click', function () {
  miniCart.classList.remove('open')
  miniCartOverlay.classList.remove('open')
  document.body.classList.remove('active', 'minicart')
  scrollLock(false)
})

// close cart if clicked outside of it
window.addEventListener('click', function (e) {
  if (document.getElementById('mini-cart-overlay').contains(e.target)) {
    // Clicked oustide mini cart
    miniCart.classList.remove('open')
    miniCartOverlay.classList.remove('open')
    document.body.classList.remove('active', 'minicart')
    scrollLock(false)
  }
})

const numberWithCommas = (x) => {
  return x
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const isInCart = (title) => {
  let isInCart = false
  miniCart.querySelectorAll('.cart-item').forEach((cartItem) => {
    cartItem.querySelector('.cart-item__title').textContent === title &&
    cartItem
      .querySelector('.cart-item-image')
      .getAttribute('data-src')
      .indexOf('no-image') > -1
      ? (isInCart = true)
      : (isInCart = false)
  })
  return isInCart
}

const refreshCartData = (data) => {
  console.log(data, 'data');
  const realCartItems = data.items
  //update total price
  const totalPriceSelector = document.getElementById('cart-total-price')
  document
    .querySelectorAll('.cart-count')
    .forEach((cartCount) => (cartCount.textContent = data.item_count))
  let totalPrice = data.total_price / 100.0
  totalPriceSelector.innerText = `${currency}${numberWithCommas(totalPrice)}`
  if (data.item_count === 0) {
    document.querySelector('.header__icons .cart-count').style.display = 'none'
    document.querySelector('.mini-cart--empty').style.display = 'block'
    document.querySelector('.cart-summary__buttons a').classList.add('disabled')
  } else {
    document.querySelector('.header__icons .cart-count').style.display = 'flex'
    document.querySelector('.mini-cart--empty').style.display = 'none'
    document
      .querySelector('.cart-summary__buttons a')
      .classList.remove('disabled')
  }
  //update line item prices
  let cartItems = document.createElement('div')
  cartItems.classList.add('cart-items__container')
  realCartItems.forEach((cartItem) => {
    let clonedElement = document
      .querySelector('.empty-cart-item > .cart-item')
      .cloneNode(true)
    clonedElement.setAttribute('data-variant-id', cartItem.variant_id)
    //update title (if new product)
    clonedElement
      .querySelector('.cart-item__title')
      .setAttribute('href', cartItem.url)
    clonedElement.querySelector('.cart-item__title').innerText = cartItem.title
    //update qty
    clonedElement.querySelector('input[name="quantity"]').value =
      cartItem.quantity
    !isInCart(cartItem.title) &&
      clonedElement
        .querySelector('.cart-item-image')
        .setAttribute(
          'data-src',
          cartItem.featured_image.url
            .replace('.jpg', '_150x150.jpg')
            .replace('.png', '_150x150.png')
        )

    //update price
    let lineItemPrice = cartItem.final_line_price / 100.0
    const priceSelector = clonedElement.querySelector('.cart-item-subtotal')
    priceSelector.innerText = `${currency}${numberWithCommas(lineItemPrice)}`

    cartItems.appendChild(clonedElement)
  })
  miniCart.querySelector('.cart-items__container').innerHTML =
    cartItems.innerHTML
  //attach event listeners
  miniCart.querySelectorAll('.cart-item').forEach((cartItem, idx) => {
    cartItem.querySelector('input[name="quantity"]').value =
      realCartItems[idx].quantity

    manageState(cartItem)
  })

  // upsell item handlers
  upsellItems.forEach((upsellItem) => {
    const upsellItemId = upsellItem?.querySelector(
      'form input[name="id"]'
    )?.value
    let upsellInCart = realCartItems.find(
      (element) => element.variant_id === parseInt(upsellItemId)
    )
    if (upsellInCart && upsellItem) upsellItem.style.display = 'none'
    else if (
      (!upsellInCart && upsellItem) ||
      (data.item_count === 0 && upsellItem)
    )
      upsellItem.style.display = 'grid'
  })

  // free shipping
  const amountLeft = freeShippingThreshold - totalPrice

  miniCart.querySelector('.free-shipping-left > #amount-left').innerText =
    currency + amountLeft.toFixed(2)
  miniCart
    .querySelector('.free-shipping-left')
    .setAttribute(
      'data-percentage',
      freeShippingThreshold <= totalPrice
        ? 100
        : 100 * (amountLeft / freeShippingThreshold).toFixed(2)
    )
    console.log(freeShippingThreshold, totalPrice, 'total price');
  if (freeShippingThreshold <= totalPrice) {
    miniCart.querySelector('.free-shipping-left').style.display = 'none'
    miniCart.querySelector('.free-shipping-qualified').style.display = 'block'
  } else {
    miniCart.querySelector('.free-shipping-left').style.display = 'block'
    miniCart.querySelector('.free-shipping-qualified').style.display = 'none'
  }

  document.body.classList.add('active', 'addtocart')
  window.setTimeout(
    () => document.body.classList.remove('active', 'addtocart'),
    2000
  )
  //console.log('refreshed');

  miniCart.querySelectorAll('img').forEach((image) => {
    image.src = image.dataset.src
  })
}

const fetchCart = () => {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((data) => {
      refreshCartData(data)
    })
}

const options = {
  attributes: true,
}

function callback(mutationList, observer) {
  mutationList.forEach(function (mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      // handle class change
      fetchCart()
    }
  })
}

const observer = new MutationObserver(callback)
observer.observe(miniCart, options)

// cart updates
const changeCartItem = (item) => {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(item),
  })
    .then((response) => {
      return response.json()
    })
    .then(function (data) {
      // This is the JSON from our response
      refreshCartData(data)
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}

const manageState = (cartItem) => {
  const id = cartItem.getAttribute('data-variant-id')
  const quantityInput = cartItem.querySelector('input[name="quantity"]')
  const deleteItem = cartItem.querySelector('.cart-item-delete')

  let quantity = parseInt(quantityInput.value)

  const qtyPlus = cartItem.querySelector('.quantity button[name="plus"]')
  const qtyMinus = cartItem.querySelector('.quantity button[name="minus"]')

  qtyPlus.addEventListener('click', function () {
    quantity = quantity + 1
    quantityInput.value = quantity

    changeCartItem({
      id: id,
      quantity: quantity,
    })
  })

  qtyMinus.addEventListener('click', function () {
    quantity = quantity - 1
    quantityInput.value = quantity
    changeCartItem({
      id: id,
      quantity: quantity,
    })
  })

  deleteItem.addEventListener('click', function () {
    changeCartItem({
      id: id,
      quantity: 0,
    })
    cartItem.remove()
  })
}

miniCart.querySelectorAll('.cart-item').forEach((cartItem) => {
  manageState(cartItem)
})

document.querySelector('.header__icons .cart-count').textContent === '0'
  ? (document.querySelector('.header__icons .cart-count').style.display =
      'none')
  : (document.querySelector('.header__icons .cart-count').style.display =
      'flex')
